<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import AlertError from "@/components/alert_error";
import { VueContentLoading } from "vue-content-loading";
import QrCodeCard from "@/components/qr_code_card";

export default {
  page: {
    title: "أستمارة قروض الاسكان",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading, QrCodeCard },
  data() {
    return {
      title: "تفاصيل الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/",
        },
        {
          text: "قروض الاسكان - الشهداء",
          href: "/government-loans/martyrs",
        },
        {
          text: "التفاصيل",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      loadingContent: true,
      martyr: null,
      qrCodeContent: null,
      showAlert: false,
    };
  },
  computed: {
    ...mapGetters("governmentLoansMartyr", ["getMartyr"]),
  },
  methods: {
    ...mapActions("governmentLoansMartyr", ["get"]),
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    fetch() {
      this.get(this.id)
        .then(() => {
          this.martyr = this.getMartyr;
          this.loadingContent = false;

          this.qrCodeContent = JSON.stringify({
            Id: this.martyr.qr_id,
            fullName: this.martyr.full_name,
            date: this.martyr.created_at,
          });
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingContent = false;
        });
    },
    // get child scores by id for family scores.
    childHasScore(id, field) {
      return this.childGetScore(id, field) != null;
    },
    childGetScore(id, field){
      let score = this.martyr.scores.family.housemates.find((p)=>p.id == id );
      if(score != null){
        return score[field];
      }
      return null;
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingContent = false;
    // }, 1000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

        <div class="card">
          <div v-if="!loadingContent" class="card-body">
            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">معلومات مقدم الطلب الاساسية</h5>
            </div>
            <div class="row about-list mb-2">
              <h4>الاسم : {{ martyr.personal_info.full_name }}</h4>
              <div class="col-md-4">
                <div class="media">
                  <label>اللقب :</label>
                  <p>{{ martyr.personal_info.family_name }}</p>
                </div>
                <div class="media">
                  <label>اسم الام الثلاثي :</label>
                  <p>{{ martyr.personal_info.mother_name }}</p>
                </div>
                <div class="media">
                  <label>تاريخ التولد :</label>
                  <p>{{ martyr.personal_info.birth_date }}</p>
                </div>
                <div class="media">
                  <label>الجنس :</label>
                  <p>{{ martyr.personal_info.gender.title }}</p>
                </div>
                <div class="media" v-if="martyr.personal_info.nationality_number != null">
                  <label>رقم البطاقة الوطنية :</label>
                  <p>{{ martyr.personal_info.nationality_number }}</p>
                </div>
                <div class="media" v-else>
                  <label>هوية الاحول المدنية :</label>
                  <p>{{ martyr.personal_info.national_id_number }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>التحصيل الدراسي :</label>
                  <p>{{ martyr.personal_info.certificate.title }}</p>
                </div>
                <div class="media">
                  <label>التخصص الدراسي :</label>
                  <p>{{ martyr.personal_info.specialization }}</p>
                </div>
                <div class="media">
                  <label>رقم الهاتف :</label>
                  <p>{{ martyr.personal_info.phone }}</p>
                </div>
                <div class="media">
                  <label>صلة القرابة من الشهيد :</label>
                  <p>
                    {{ martyr.relation_relative.title }}
                    <span class="degree-display">{{
                      martyr.scores.basic.marital_status_relation_relative
                    }}</span>
                  </p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>الحالة الاجتماعية :</label>
                  <p>{{ martyr.personal_info.marital_status.title }}</p>
                </div>
                <div class="media">
                  <label>الوضع الصحي :</label>
                  <p>
                    {{ martyr.health_statuses.map((x) => x.title).join(", ") }}
                    <span class="degree-display">{{
                      martyr.scores.basic.health_statuses
                    }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>العمل :</label>
                  <p>
                    {{ martyr.job.title }}
                    <span class="degree-display">{{ martyr.scores.basic.work }}</span>
                  </p>
                </div>
                <div v-if="martyr.job.id == 3" class="media">
                  <label>مكان العمل :</label>
                  <p>{{ martyr.job_title }}</p>
                </div>
              </div>
            </div>
            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">عنوان السكن لمقدم الطلب</h5>
            </div>
            <div class="row about-list mb-2">
              <div class="col-md-4">
                <div class="media">
                  <label>المحافظة :</label>
                  <p>{{ martyr.address.city.title }}</p>
                </div>
                <div class="media">
                  <label>محلة :</label>
                  <p>{{ martyr.address.mahla }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>القضاء :</label>
                  <p>{{ martyr.address.district }}</p>
                </div>
                <div class="media">
                  <label>زقاق :</label>
                  <p>{{ martyr.address.zqaq }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>الناحية :</label>
                  <p>{{ martyr.address.region }}</p>
                </div>
                <div class="media">
                  <label>دار :</label>
                  <p>{{ martyr.address.dar }}</p>
                </div>
              </div>
            </div>
            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">معلومات الملكية لمقدم الطلب</h5>
            </div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>هل تمتلك عقار بأسمك :</label>
                  <p>
                    {{ martyr.housing_info.real_estate.title }}
                    <span class="degree-display">{{
                      martyr.scores.housing.real_estate
                    }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>نوع السكن :</label>
                  <p>
                    {{ martyr.housing_info.accommodation.title }}
                    <span class="degree-display">{{
                      martyr.scores.housing.accommodation
                    }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>خصوصية السكن :</label>
                  <p>
                    {{ martyr.housing_info.address_privacy.title }}
                    <span class="degree-display">{{
                      martyr.scores.housing.address_privacy
                    }}</span>
                  </p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>نوع البناء :</label>
                  <p>
                    {{ martyr.housing_info.build_material_type.title }}
                    <span class="degree-display">{{
                      martyr.scores.housing.build_material_type
                    }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>حالة البناء :</label>
                  <p>
                    {{ martyr.housing_info.building_condition.title }}
                    <span class="degree-display">{{
                      martyr.scores.housing.building_condition
                    }}</span>
                  </p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>مساحة السكن :</label>
                  <p>
                    {{ martyr.housing_info.area }}
                    <span class="degree-display">{{ martyr.scores.housing.area }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>عدد الطوابق :</label>
                  <p>{{ martyr.housing_info.floors_number }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات الشهيد</h5></div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>الاسم :</label>
                  <p>{{ martyr.martyr.personal_info.full_name }}</p>
                </div>
                <div class="media">
                  <label>اللقب :</label>
                  <p>{{ martyr.martyr.personal_info.family_name }}</p>
                </div>
                <div class="media">
                  <label>اسم الام الثلاثي :</label>
                  <p>{{ martyr.martyr.personal_info.mother_name }}</p>
                </div>
                <div class="media">
                  <label>تاريخ التولد :</label>
                  <p>{{ martyr.martyr.personal_info.birth_date }}</p>
                </div>
                <div class="media">
                  <label>الجنس :</label>
                  <p>{{ martyr.martyr.personal_info.gender.title }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>الحالة الاجتماعية :</label>
                  <p>{{ martyr.martyr.personal_info.marital_status.title }}</p>
                </div>
                <div class="media">
                  <label>التحصيل الدراسي :</label>
                  <p>{{ martyr.martyr.personal_info.certificate.title }}</p>
                </div>
                <div class="media">
                  <label>التشكيل :</label>
                  <p>{{ martyr.martyr.dept }}</p>
                </div>
                <div class="media">
                  <label>الرقم التقاعدي :</label>
                  <p>{{ martyr.martyr.retirement_number }}</p>
                </div>
                <div class="media">
                  <label>محافظة السكن :</label>
                  <p>{{ martyr.martyr.city.title }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>تاريخ الاستشهاد :</label>
                  <p>{{ martyr.martyr.date_marty }}</p>
                </div>
                <div class="media">
                  <label>محل الحادث :</label>
                  <p>{{ martyr.martyr.place_marty }}</p>
                </div>
                <div class="media">
                  <label>هل الشهيد مفقود الاثر :</label>
                  <p>
                    {{ martyr.martyr.no_exists_body ? "نعم" : "لا" }}
                    <span class="degree-display">{{ martyr.scores.basic.grants }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>المنح الحكومية :</label>
                  <p>
                    {{ martyr.martyr.grants.map((x) => x.title).join(", ") }}
                    <span class="degree-display">{{
                      martyr.scores.basic.no_exists_body
                    }}</span>
                  </p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">مواصفات الوحدة السكنية</h5></div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>الوحدة السكنية :</label>
                  <p>{{ martyr.housing.unit.title }}</p>
                </div>
                <div class="media">
                  <label>المحافظة :</label>
                  <p>{{ martyr.housing.city.title }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>نوع الوحدة السكنية :</label>
                  <p>{{ martyr.housing.unit_type.title }}</p>
                </div>
                <!-- <div class="media">
                  <label>نمط الوحدة السكنية :</label>
                  <p>{{ martyr.housing.build_style.title }}</p>
                </div> -->
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>مساحة الوحدة السكنية :</label>
                  <p>{{ martyr.housing.unit_area.title }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">المستفيدين في القسام الشرعي</h5>
            </div>
            <div class="row about-list">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-sm text-center mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>ت</th>
                        <th>الاسم</th>
                        <th>صلة القرابة</th>
                        <th>رقم الهاتف</th>
                        <th>الراتب التقاعدي</th>
                        <th>عنوان السكن</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(heir, index) in martyr.martyr.heirs" :key="heir">
                        <th scope="row">{{ index + 1 }}</th>
                        <td>{{ heir.full_name }}</td>
                        <td>{{ heir.relation_relative.title }}</td>
                        <td>{{ heir.phone }}</td>
                        <td>{{ heir.pension_amount }}</td>
                        <td>{{ heir.address }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات عائلة مقدم الطلب</h5></div>
            <div class="row about-list">
              <div class="col-md-12">
                <div role="tablist" class="tablist">
                  <b-card
                    v-for="(person, index) in martyr.housemates"
                    :key="person"
                    no-body
                    class="mb-1 shadow-none"
                  >
                    <b-card-header header-tag="header" role="tab">
                      <h6 class="m-0">
                        <a
                          v-b-toggle="'accordion-' + index"
                          class="text-dark"
                          href="javascript: void(0);"
                          ><span>{{ index + 1 }}</span
                          >{{ person.personal_info.full_name }}</a
                        >
                        <a
                          v-if="person.basic_url"
                          :href="person.basic_url"
                          target="_blank"
                          class="float-end pt-1"
                        >
                          المرفقات الثبوتية
                        </a>
                        <a
                          v-if="person.health_url"
                          :href="person.health_url"
                          target="_blank"
                          class="float-end pt-1 mx-2"
                        >
                          مرفق الحالة الصحية
                        </a>
                      </h6>
                    </b-card-header>
                    <b-collapse
                      :id="'accordion-' + index"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="media">
                                <label>اللقب :</label>
                                <p>{{ person.personal_info.family_name }}</p>
                              </div>
                              <div class="media">
                                <label>اسم الام الثلاثي :</label>
                                <p>{{ person.personal_info.mother_name }}</p>
                              </div>
                              <div class="media">
                                <label>تاريخ التولد :</label>
                                <p>
                                  {{ person.personal_info.birth_date }}
                                  <span
                                    class="degree-display"
                                    v-if="childHasScore(person.id, 'old')"
                                    >{{ childGetScore(person.id, "old") }}</span
                                  >
                                </p>
                              </div>
                              <div class="media">
                                <label>الجنس :</label>
                                <p>{{ person.personal_info.gender.title }}</p>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="media">
                                <label>الحالة الاجتماعية :</label>
                                <p>{{ person.personal_info.marital_status.title }}</p>
                              </div>
                              <div class="media">
                                <label>التحصيل الدراسي :</label>
                                <p>{{ person.personal_info.certificate.title }}</p>
                              </div>
                              <div class="media">
                                <label>رقم الهاتف :</label>
                                <p>{{ person.personal_info.phone }}</p>
                              </div>
                              <div class="media">
                                <label>صلة القرابة من مقدم الطلب :</label>
                                <p>{{ person.relation_relative.title }}</p>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="media">
                                <label>هل تمتلك عقار بأسمك :</label>
                                <p>{{ person.real_estate.title }}</p>
                              </div>
                              <div class="media">
                                <label>الوضع الصحي :</label>
                                <p>
                                  {{
                                    person.health_statuses.map((x) => x.title).join(", ")
                                  }}
                                  <span
                                    class="degree-display"
                                    v-if="childHasScore(person.id, 'health')"
                                    >{{ childGetScore(person.id, "health") }}</span
                                  >
                                </p>
                              </div>
                              <div class="media">
                                <label>العمل :</label>
                                <p>
                                  {{ person.job.title }}
                                  <span
                                    class="color-red"
                                    v-if="childHasScore(person.id, 'work')"
                                    >: {{ childGetScore(person.id, "work") }}</span
                                  >
                                </p>
                              </div>
                              <div v-if="person.job.id == 3" class="media">
                                <label>مكان العمل :</label>
                                <p>{{ person.job_title }}</p>
                              </div>
                            </div>
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">تنزيل المرفقات</h5></div>
            <div class="row about-list">
              <div class="col-md-6 d-grid">
                <a :href="martyr.basic_url" target="_blank">
                  <b-button
                    :disabled="!martyr.basic_url"
                    variant="primary"
                    type="button"
                    class="mb-2 w-100"
                    >المرفقات الثبوتية</b-button
                  >
                </a>
                <a :href="martyr.health_url" target="_blank">
                  <b-button
                    :disabled="!martyr.health_url"
                    variant="primary"
                    type="button"
                    class="mb-2 w-100"
                    >مرفق الحالة الصحية</b-button
                  >
                </a>
                <a :href="martyr.martyr.basic_url" target="_blank">
                  <b-button
                    :disabled="!martyr.martyr.basic_url"
                    variant="primary"
                    type="button"
                    class="mb-2 w-100"
                    >مرفق تاييد الاستشهاد</b-button
                  >
                </a>
                <a :href="martyr.martyr.qssam_url" target="_blank">
                  <b-button
                    :disabled="!martyr.martyr.qssam_url"
                    variant="primary"
                    type="button"
                    class="mb-2 w-100"
                    >مرفق القسام الشرعي</b-button
                  >
                </a>

                <p class="text-center">
                  <span class="mx-3">درجة السكن : {{ martyr.scores.housing.total }}</span>
                  <span class="mx-3">الدرجة الشخصية : {{ martyr.scores.basic.total }}</span>
                  <span class="mx-3">درجة العائلة : {{ martyr.scores.family.total }}</span>
                  <span class="mx-3">المجموع : {{ martyr.scores.total }}</span>
                  <span class="mx-3">النسبة المئوية : {{ martyr.scores.avg }}</span>
                  <span class="mx-3">النسبة المئوية X 3 : {{ martyr.scores.avg3 }}</span>
                </p>
              </div>
              <div class="col-md-6">
                <QrCodeCard
                  title="استمارة الوحدات السكنية"
                  :fullName="this.martyr.personal_info.full_name"
                  :date="this.martyr.created_at"
                  :Id="this.martyr.qr_id"
                  :qrCodeContent="this.qrCodeContent"
                ></QrCodeCard>
              </div>
            </div>
            <div class="mt-3">
              <hr />
              <b-button
                class=""
                type="button"
                to="/housing-units/martyrs"
                variant="secondary"
                >رجوع</b-button
              >
            </div>
          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
